import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { convertStatus, compareDepartments, compareVisibility } from './utils.js';
import { UPDATE_AUTHKEY, ZENDESK_UPDATE_UNREAD_COUNT, ZENDESK_UPDATE_LANGUAGE, ZENDESK_UPDATE_IDENTITY, ZENDESK_UPDATE_TAGS, ZENDESK_UPDATE_NOTIFICATIONS, ZENDESK_UPDATE_DEPARTMENTS, SHOW_WIDGET, ZENDESK_SET_LAUNCHER_ELIGIBLE, ZENDESK_UPDATE_VISIBILITY, ZENDESK_INITIALIZE, states, ZENDESK_LOAD, CHATBOT_INITIALIZE, CHATBOT_LOAD } from './constants.js';

function reducer(state, action) {
  switch (action.type) {
    case CHATBOT_LOAD:
      {
        if (!state.disabled && state.chatbot.id) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            chatbot: _objectSpread2(_objectSpread2({}, state.chatbot), {}, {
              status: states.LOADING
            })
          });
        }

        return state;
      }

    case CHATBOT_INITIALIZE:
      {
        if (state.disabled || !action.payload) {
          return state;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          chatbot: _objectSpread2(_objectSpread2({}, state.chatbot), {}, {
            status: states.INITIALIZED,
            element: action.payload
          })
        });
      }

    case ZENDESK_LOAD:
      {
        if (state.disabled) {
          return state;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          zendesk: _objectSpread2(_objectSpread2({}, state.zendesk), {}, {
            status: states.LOADING
          })
        });
      }

    case ZENDESK_INITIALIZE:
      {
        // if using chatbot, then Chatbot DOM element must be initialized before
        // zendesk can be initalized
        var waitForChatbot = state.chatbot.status !== states.OFF && state.chatbot.status !== states.INITIALIZED;

        if (state.disabled || waitForChatbot || !action.payload) {
          return state;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          zendesk: _objectSpread2(_objectSpread2({}, state.zendesk), {}, {
            status: states.INITIALIZED
          })
        });
      }

    /**
     * Updates state with decision of zendesk visibility,
     * which is used to update zendesk once the decision is final.
     */

    case ZENDESK_UPDATE_VISIBILITY:
      {
        var visibility = compareVisibility(state.showWidget, state.zendesk.launcherEligible, state.forceOpenOnUnreadMsgs, state.chatbot, state.disabled);
        return _objectSpread2(_objectSpread2({}, state), {}, {
          zendesk: _objectSpread2(_objectSpread2({}, state.zendesk), {}, {
            visibility: visibility
          })
        });
      }

    case ZENDESK_SET_LAUNCHER_ELIGIBLE:
      {
        // if props specify hidden, then launcher should not show.
        if (state.hidden || !action.payload) {
          return state;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          zendesk: _objectSpread2(_objectSpread2({}, state.zendesk), {}, {
            launcherEligible: action.payload
          })
        });
      }

    case SHOW_WIDGET:
      {
        // check what visibility should be, now that widget state has been toggled.
        var _visibility = compareVisibility(action.payload, state.zendesk.launcherEligible, state.forceOpenOnUnreadMsgs, state.chatbot, state.disabled);

        return _objectSpread2(_objectSpread2({}, state), {}, {
          showWidget: action.payload,
          zendesk: _objectSpread2(_objectSpread2({}, state.zendesk), {}, {
            visibility: _visibility
          })
        });
      }

    case ZENDESK_UPDATE_DEPARTMENTS:
      {
        var primary = convertStatus(action.payload.primary || state.primaryDepartment);
        var fallback = convertStatus(action.payload.fallback || state.fallbackDepartment);
        var {
          status,
          selectDepartmentId
        } = compareDepartments(primary, fallback); // update settings only if status is online

        if (status === "online") {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            zEsettings: {
              webWidget: _objectSpread2(_objectSpread2({}, state.zEsettings.webWidget), {}, {
                chat: _objectSpread2(_objectSpread2({}, state.zEsettings.webWidget.chat), {}, {
                  departments: _objectSpread2(_objectSpread2({}, state.zEsettings.webWidget.chat.departments), {}, {
                    select: selectDepartmentId
                  })
                })
              })
            },
            departments: {
              primary,
              fallback
            },
            chatStatus: status
          });
        } // update departments to internal state anyway

        /* istanbul ignore next: test is hard-coded so callback returns "online" */


        return _objectSpread2(_objectSpread2({}, state), {}, {
          departments: {
            primary,
            fallback
          },
          chatStatus: status
        });
      }

    case ZENDESK_UPDATE_NOTIFICATIONS:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          zEsettings: {
            webWidget: _objectSpread2(_objectSpread2({}, state.zEsettings.webWidget), {}, {
              chat: _objectSpread2(_objectSpread2({}, state.zEsettings.webWidget.chat), {}, {
                notifications: {
                  mobile: _objectSpread2({}, action.payload)
                }
              })
            })
          }
        });
      }

    case ZENDESK_UPDATE_TAGS:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          zEsettings: {
            webWidget: _objectSpread2(_objectSpread2({}, state.zEsettings.webWidget), {}, {
              chat: _objectSpread2(_objectSpread2({}, state.zEsettings.webWidget.chat), {}, {
                tags: action.payload
              })
            })
          }
        });
      }

    case ZENDESK_UPDATE_IDENTITY:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          zEcommands: _objectSpread2(_objectSpread2({}, state.zEcommands), {}, {
            prefill: {
              name: {
                value: action.payload.name,
                readOnly: true
              },
              email: {
                value: action.payload.email,
                readOnly: false
              }
            },
            identify: {
              name: action.payload.name,
              email: action.payload.email
            }
          })
        });
      }

    case ZENDESK_UPDATE_LANGUAGE:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          zEcommands: _objectSpread2(_objectSpread2({}, state.zEcommands), {}, {
            setLocale: action.payload
          })
        });
      }

    case ZENDESK_UPDATE_UNREAD_COUNT:
      {
        // Only update if the chat is closed
        if (!state.showWidget) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            unreadCount: action.payload
          });
        } else {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            unreadCount: 0
          });
        }
      }

    case UPDATE_AUTHKEY:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          authKey: action.payload
        });
      }

    /* istanbul ignore next: standard pattern */

    default:
      {
        return state;
      }
  }
}
function useChatReducer(props) {
  var initialState = {
    /**
     * https://developer.zendesk.com/api-reference/widget/settings/
     */
    zEsettings: {
      webWidget: {
        chat: {
          concierge: {
            avatarPath: props.translations["chat.concierge.avatarPath"],
            name: props.translations["chat.concierge.name"],
            title: {
              "*": props.translations["chat.concierge.title"]
            }
          },
          departments: {
            enabled: [props.departmentId, props.fallbackDepartmentId],
            select: props.departmentId
          },
          notifications: {
            mobile: {
              disable: props.forceOpenOnUnreadMsgs || props.disableMobileNotifications
            }
          },
          offlineForm: {
            greeting: {
              "*": props.translations["chat.offlineForm.greeting"]
            }
          },
          tags: props.tags,
          title: {
            "*": props.translations["chat.title"]
          }
        },
        color: {
          launcher: props.color,
          theme: props.color
        },
        launcher: {
          chatLabel: {
            "*": props.translations["launcher.chatLabel"]
          },
          label: {
            "*": props.translations["launcher.label"]
          }
        }
      }
    },

    /**
     * https://developer.zendesk.com/api-reference/widget/core/#commands
     */
    zEcommands: {
      setLocale: props.language,
      prefill: {
        name: {
          value: props.name,
          readOnly: true
        },
        email: {
          value: props.email,
          readOnly: false
        }
      },
      identify: {
        name: props.name,
        email: props.email
      }
    },

    /**
     * `authKey`. A unique key that if changed, triggers the widget to
     * reauthenticate with the server
     * @type {number}
     */
    authKey: "",

    /**
     * `chatStatus`. Updates $zopim chat api with chat status.
     * @type {("online"|"offline")}
     */
    chatStatus: undefined,
    disabled: props.disabled || false,

    /**
     * The values below are used for tracking internal state, and are not related
     * to the zendesk/chatcreate apis.
     */
    chatbot: {
      status: states.OFF,
      element: null,
      id: props.chatBotId
    },
    departments: {
      primary: {
        id: props.departmentId,
        name: "",
        status: ""
      },
      fallback: {
        id: props.fallbackDepartmentId,
        name: "",
        status: ""
      }
    },
    forceOpenOnUnreadMsgs: props.forceOpenOnUnreadMsgs || false,
    hidden: props.hidden || false,
    // `showWidget`, FKA `showTab`. State boolean that decides if chat should be
    // open or collapsed. This was false by default.
    showWidget: false,
    tags: props.tags || [],
    unreadCount: 0,
    zendesk: {
      status: states.UNINITIALIZED,

      /**
       * visibility. Used to define whether the widget, launcher, or neither
       * should show. Ultimately triggers the calls to zendesk for
       * hiding/showing/closing/opening the widget.
       * @type {("hide"|"launcher"|"widget")}
       */
      visibility: undefined,

      /**
       * `zeLauncherEligible`, FKA `visible`. State boolean that takes care of
       * whether the launcher should be visible or not for current window.innerWidth
       * @type {boolean}
       */
      launcherEligible: false
    }
  };
  return React.useReducer(reducer, initialState);
}

export { reducer, useChatReducer };
